import i18next from 'i18next';
import React from 'react';

import { DetailsGrid } from '@indigo-ag/component-module';
import { FinancingContact } from '@indigo-ag/schema';
import { getFormattedTaxIdentifier } from '../../pages/ContactDetailsPage/utils';

interface Props {
  contact: FinancingContact;
}

export const ContactDetailsGrid = ({
  contact: { address, cellPhoneNumber, email, maritalStatus, name, phoneNumber, taxIdentifier }
}: Props) => {
  const { street, street2, adminArea, state, city, locality, postalCode } = address ?? {};

  const emptyValue = '-';

  return (
    <DetailsGrid
      columnWidth={250}
      items={[
        { label: i18next.t('fullName'), value: name },
        { label: i18next.t('cpfNumber'), value: getFormattedTaxIdentifier(taxIdentifier) ?? emptyValue },
        { label: i18next.t('email'), value: email ?? emptyValue },
        { label: i18next.t('phoneNumber'), value: phoneNumber ?? emptyValue },
        { label: i18next.t('cellPhoneNumber'), value: cellPhoneNumber ?? emptyValue },
        { label: i18next.t('maritalStatus'), value: maritalStatus ?? emptyValue },
        { label: i18next.t('address'), value: street ?? emptyValue },
        { label: i18next.t('address2'), value: street2 ?? emptyValue },
        { label: i18next.t('state'), value: locality ?? state ?? emptyValue },
        { label: i18next.t('city'), value: adminArea ?? city ?? emptyValue },
        { label: i18next.t('postalCode'), value: postalCode ?? emptyValue }
      ]}
    />
  );
};
